import BaseApiRepository from '../_common/BaseApiRepository';

class BlacklistApiRepository extends BaseApiRepository {
    async getBlacklist() {
        const response = await this.apiRequest('GET', 'communication-channels/blacklist');
        return response.data;
    }

    async addToBlacklist(request) {
        const response = await this.apiRequest('POST', 'communication-channels/blacklist/add', request);
        return response.data;
    }

    async removeFromBlacklist(request) {
        const response = await this.apiRequest('POST', 'communication-channels/blacklist/remove', request);
        return response.data;
    }
}

export default new BlacklistApiRepository();
